var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-align-center mr-4"},[_c('rd-text',{attrs:{"useByTable":false,"width":"65","label":"店铺"}},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row['shop_name'])))]),_c('ID-tag',{attrs:{"label":"店铺ID","id":_vm.row.shop_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }